import React, { useEffect } from "react";
import { Image, ScrollView, StyleSheet, Text, View } from "react-native"
import CustomPressable from "../customPressable/customPressable";
import { CROSS, INFO_CIRCLE } from '../../assets';
import { ImageComp } from "../Image/Image";
import { useCssStyle } from "../../customHook/getCssStyle";
import HeaderWithBack from "../Header/headerWithBack";

export const PicturePreview = (props) => {

    const { pictureUri, imageDescrption, handleNextPicturePreview, handleClosePicturePreview, handleGoBack } = props;

    const getStyles = useCssStyle();


    useEffect(() => {
        console.log("we are in picture preview");
    }, [])

    return (
        <View style={getStyles(['widgetRootContainer', 'picturePreviewRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView contentContainerStyle={getStyles(['widgetmainContainer', 'picturePreviewMainContainer'])} showsVerticalScrollIndicator={false}>

                <View style={getStyles(['widgetmainContainerHeaderContainer', 'picturePreviewHeaderContainer'])}>
                    <ImageComp
                        style={getStyles(['widgetmainContainerHeaderImg', 'picturePreviewHeaderImg'])}
                        resizeMode={"cover"}
                        source={pictureUri}
                    />
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'picturePreviewMainContainerChildContainer'])}>

                    <View style={getStyles(['picturePreviewMainContainerChildContainer_textContainer'])}>
                        <Text style={getStyles(['picturePreviewMainContainerChildContainer_textContainer_title'])}>{'Good job!'}</Text>
                        <Text style={getStyles(['picturePreviewMainContainerChildContainer_textContainer_subtitle'])}>
                            {imageDescrption || "Do you want to use this photo?"}
                        </Text>
                    </View>

                    <View style={getStyles(['picturePreviewMainContainerChildContainer_buttonContainer'])}>
                        <CustomPressable
                            style={getStyles(['primaryBtn'])}
                            onPress={handleNextPicturePreview}
                        >
                            <Text style={getStyles(['primaryBtnTxt'])}>Yes, save the photo</Text>
                        </CustomPressable>

                        <CustomPressable
                            style={getStyles(['secondaryBtn'])}
                            onPress={handleClosePicturePreview}
                        >
                            <Text style={getStyles(['secondaryBtnTxt'])}>No, take another one</Text>
                        </CustomPressable>
                    </View>
                </View>
            </ScrollView>
        </View >
    )
}